export function useHeaderAsState(name: string): string | undefined {
  const state = useState<string>(name);
  if (!state.value && import.meta.server) {
    const value = useRequestHeader(name);
    if (value) {
      state.value = value;
    }
  }
  return state.value;
}
